// extracted by mini-css-extract-plugin
export var alternate = "_k-h";
export var black = "_k-3";
export var blue = "_k-d";
export var blueLight = "_k-c";
export var brand = "_k-7";
export var error = "_k-9";
export var gray = "_k-6";
export var grayBlue = "_k-b";
export var iconWrapper = "_k-4";
export var indigo = "_k-e";
export var orange = "_k-g";
export var pink = "_k-f";
export var primary = "_k-0";
export var purple = "_k-8";
export var success = "_k-5";
export var warning = "_k-a";
export var white = "_k-1";
export var whiteSuccess = "_k-2";